<script setup>
import ActionSection from '@/Components/ActionSection.vue';
import SetupTwoFactorAuthenticationForm from "@/Pages/Profile/Partials/SetupTwoFactorAuthenticationForm.vue";

const props = defineProps({
  requiresConfirmation: Object,
});

const providers = [
  {
    name: 'Google',
    identifier: '2fa',
    description: 'When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone\'s Google Authenticator application.'
  },
  {
    name: 'SMS',
    identifier: 'sms',
    description: 'When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from a SMS on your phone number.'
  }
];
</script>

<template>
  <ActionSection>
    <template #title>
      Two Factor Authentication
    </template>

    <template #description>
      Add additional security to your account using two factor authentication.
    </template>

    <template #content>
      <div v-for="provider in providers">
        <SetupTwoFactorAuthenticationForm
          :provider="provider"
          :requires-confirmation="props.requiresConfirmation[provider.identifier].is_in_progress"
        />
      </div>
    </template>
  </ActionSection>
</template>
